// extracted by mini-css-extract-plugin
export default {"container":"components-sidebar_container","fullHeight":"components-sidebar_fullHeight","overlay":"components-sidebar_overlay"};